import type { CSSProperties } from 'react'
import { useTheme } from '@/lib/theme'

type BrandLogoProps = {
  className?: string
  size?: number
  style?: CSSProperties
}

export function BrandLogo({ className, size = 34, style }: BrandLogoProps) {
  const { theme } = useTheme()
  const src = theme === 'dark' ? '/somicast-light-logo.svg' : '/somicast-dark-logo.png'

  return (
    <img
      className={className}
      src={src}
      alt=""
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(5, Math.round(size * 0.2)),
        objectFit: 'contain',
        display: 'block',
        flexShrink: 0,
        ...style,
      }}
    />
  )
}
